import { render } from "./expired.vue?vue&type=template&id=0861d138&scoped=true"
import script from "./expired.vue?vue&type=script&lang=js"
export * from "./expired.vue?vue&type=script&lang=js"

import "./expired.vue?vue&type=style&index=0&id=0861d138&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zjtx_club\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0861d138"]])

export default __exports__